import isEmpty from 'lodash/isEmpty';
import * as serviceTypes from '../../../data/booking/constants/service_types';
import { createMoney } from '../../../data/shared/money';

const addServiceRouteId = (service) => {
    const routeId = service.hasOwnProperty('route') && !isEmpty(service.route) ? service.route.id : null;

    return {
        ...service,
        routeId
    };
};

const addServiceLineId = (service) => {
    const lineId = service.hasOwnProperty('line') && !isEmpty(service.line) ? service.line.id : null;

    return {
        ...service,
        lineId
    };
};

const getItemPrice = (serviceType, item) => {
    if (null == item.price) {
        return null;
    }

    const quantity = getServiceItemQuantity(serviceType, item);

    return createMoney({
        amount: parseInt(item.price.amount) * quantity,
        currency: item.price.currency
    });
};

const getServiceItemQuantity = (serviceType, item) => {
    switch (serviceType) {
        case serviceTypes.BAG_TRANSPORT:
            return parseInt(item.bags);
        case serviceTypes.BIKE_TRANSPORT:
            return parseInt(item.bikes);
        case serviceTypes.PEOPLE_TRANSPORT:
            return parseInt(item.people);
        case serviceTypes.CAR_TRANSPORT:
        case serviceTypes.CAR_PARKING:
            return parseInt(item.vehicleCount);
        case serviceTypes.REGULAR_SHUTTLE:
            return parseInt(item.people);
        case serviceTypes.CANCELLATION:
            return 1;
        case serviceTypes.CUSTOM:
            return parseInt(item.quantity);
    }

    return 0;
};

export {
    addServiceLineId,
    addServiceRouteId,
    getItemPrice,
    getServiceItemQuantity
};
